enum EditorType {
  CASE = 'caseEditor',
  FOLLOWUP = 'followUpEditor',
}

export default EditorType
